<template>
  <v-menu
    open-on-hover
    :nudge-width="200"
    offset-y
    :close-on-content-click="false"
    max-height="80vh"
  >
    <template #activator="{ on }">
      <v-icon
        v-on="on"
        small
        rigth
        class="ml-2 left"
      >
        info_outline
      </v-icon>
    </template>

    <v-sheet
      max-width="600"
      :color="$vuetify.theme.currentTheme.background"
      class="pa-2"
    >
      <quiz-student-info-summary
        :quiz="quiz"
        :quizzes-attempt-summary="quizzesAttemptSummary"
        :session="session"
      />
    </v-sheet>
  </v-menu>
</template>

<script>
import { useQuizzesAttemptSummary } from "@/composables/useQuizzesAttemptSummary"
import { toRefs } from "vue"
import QuizStudentInfoSummary from "./quiz_student_info_summary.vue"

export default {
  name: "QuizStudentMenuInfo",
  components: { QuizStudentInfoSummary },
  props: {
    instance: {
      type: Object,
      required: true,
    },
    quiz: {
      type: Object,
      required: true,
    },
    schoolsUser: {
      type: Object,
      required: true,
    },
    quizzesAttemptSummary: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { quizzesAttemptSummary } = toRefs(props)
    const { remainingTimeFormatted } = useQuizzesAttemptSummary(quizzesAttemptSummary)
    return {
      remainingTimeFormatted,
    }
  },
  data: () => ({
    intervalMethod: null,
  }),
  computed: {
    isDisplayed() {
      return !!this.quizzesAttemptSummary.submission_deadline_at
    },
  },

}
</script>

<style>

</style>
